import { render, staticRenderFns } from "./RecommendedProduct.vue?vue&type=template&id=53462b76&scoped=true&"
import script from "./RecommendedProduct.vue?vue&type=script&lang=js&"
export * from "./RecommendedProduct.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedProduct.vue?vue&type=style&index=0&id=53462b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53462b76",
  null
  
)

export default component.exports